// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"8928ab8e","134":"ef9551d5","762":"c231d922","800":"87ac2ee5","906":"5d0376cc"}[chunkId] + ".css";
};